import React, { useRef, useEffect } from 'react';
import './styles.css'

export default function MediaColumnsScroll({ config }) {
    const maxHeight=400

    const colRefs = useRef([]);

    // Helper to set the scroll distance for each column
    const setPingPongDistance = () => {
        colRefs.current.forEach(col => {
            if (col) {
                const scrollHeight = col.scrollHeight;
                const distance = Math.max(0, scrollHeight - maxHeight);
                col.style.setProperty('--pingpong-distance', `${distance}px`);
            }
        });
    };

    useEffect(() => {
        setPingPongDistance();
        // Also update on window resize
        window.addEventListener('resize', setPingPongDistance);
        return () => window.removeEventListener('resize', setPingPongDistance);
    }, [config]);

    // Ensure update after images load
    useEffect(() => {
        const imgs = document.querySelectorAll('.galery-scroll-img');
        let loaded = 0;
        imgs.forEach(img => {
            if (img.complete) {
                loaded++;
                if (loaded === imgs.length) setPingPongDistance();
            } else {
                img.onload = () => {
                    loaded++;
                    if (loaded === imgs.length) setPingPongDistance();
                };
            }
        });
    }, [config]);

    return (
        <div className='galery-scroll' style={{
            height: maxHeight,
            maxWidth: '400px',
            margin: "0 auto"
        }}>
            {
                config.content.map((col, i) => (
                    <div
                        className={`galery-scroll-col ${i % 2 === 0 ? 'pingpong-up' : 'pingpong-down'}`}
                        style={{
                            marginTop: `${((i + 3) % 2 === 0 ? (i + 1) * 48 : (i + 1) * (-18))}px`
                        }}
                        key={i}
                        data-col-idx={i}
                        ref={el => colRefs.current[i] = el}
                    >
                        {col.map((imgSrc, k) => (
                            <img
                                src={imgSrc}
                                key={k}
                                className='galery-scroll-img'
                            />
                        ))}
                    </div>
                ))
            }
        </div>
    )
}